import { render } from "./contentCategoryOverview.vue?vue&type=template&id=579add62&scoped=true&ts=true"
import script from "./contentCategoryOverview.vue?vue&type=script&lang=ts"
export * from "./contentCategoryOverview.vue?vue&type=script&lang=ts"

import "./contentCategoryOverview.vue?vue&type=style&index=0&id=579add62&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579add62"]])

export default __exports__